import React from "react";
import ReactDOM from "react-dom";
import "./assets/styles/main.scss";
import "./index.scss";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "./styles/tailwind.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import GlobalProvider from "./context/Provider";


ReactDOM.render(
<React.StrictMode>
    <Router>
      <GlobalProvider>
        <App/>
      </GlobalProvider>
    </Router >
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
